/**
 * 中文文案
 * 用途：站点默认语言包（zh-CN）
 * 用法：由 i18n/index.js 注册，组件内通过 t('key') 读取
 */
export default {
  common: {
    brandLogoAlt: '品牌 Logo',
    home: '首页',
    cases: '采购实例',
    contact: '联系我们',
    getQuote: '获取报价',
    backHome: '返回首页',
    email: '邮箱',
    phone: '电话',
    loading: '加载中…',
    loadFailed: '数据加载失败，请确认 API 服务已启动。'
  },
  nav: {
    homeAria: '返回首页'
  },
  media: {
    video: '视频',
    empty: '暂无媒体内容',
    videoUnsupported: '您的浏览器不支持视频播放。',
    videoThumb: '切换到视频',
    imageThumb: '切换到图片'
  },
  home: {
    title: '发现优质货源，高效完成采购',
    subtitle:
      '浏览精选商品图片，点击即可查看规格、交期与定制说明，快速对接合适的供应方案。',
    browseProducts: '浏览商品',
    galleryTitle: '商品展示',
    galleryHint: '点击任意商品图片查看详情',
    filterLabel: '商品类别',
    filterAll: '全部',
    filterEmpty: '该类别暂无商品，请切换其他类别。'
  },
  categories: {
    industrial: '工业用品',
    home: '家居百货',
    sportsOutdoor: '运动户外',
    kitchen: '厨房用品',
    electronics: '消费电子',
    office: '办公用品',
    toys: '玩具礼品',
    bags: '箱包配件',
    tableware: '餐厨礼品',
    lighting: '灯具照明',
    sportsProtection: '运动防护',
    daily: '日用百货'
  },
  product: {
    backList: '← 返回商品列表',
    moq: '起订量：',
    material: '材质：',
    leadTime: '交期：',
    inquire: '咨询采购',
    keepBrowsing: '继续浏览',
    notFoundTitle: '未找到该商品',
    notFoundDesc: '商品可能已下架，或链接无效。'
  },
  contact: {
    title: '联系我们',
    subtitle: '从一次问候开始。告诉我们您的采购或定制需求，我们会尽快与您对接。',
    infoTitle: '联系信息',
    officeLabel: '中国办公室',
    officeAddress: '广东省广州市花都区花山镇',
    emailValue: "2017emilyli{'@'}gmail.com",
    whatsappLabel: 'WhatsApp',
    whatsappValue: '18666080334',
    workHoursLabel: '工作时间',
    workHours: '周一至周五 09:00 – 18:00（GMT+8）',
    formTitle: '发送询盘',
    formTip: '填写以下信息，我们会尽快回复您。',
    name: '姓名 *',
    namePlaceholder: '请输入您的姓名',
    company: '公司',
    companyPlaceholder: '公司名称（可选）',
    emailLabel: '邮箱 *',
    phoneLabel: '电话',
    phonePlaceholder: '方便联系的手机号',
    help: '您需要什么帮助？ *',
    helpPlaceholder: '请描述商品品类、预计数量、交期或其他需求',
    wantCall: '希望安排电话沟通',
    submit: '提交询盘',
    submitting: '提交中…',
    errorRequired: '请完整填写必填项。',
    errorEmail: '请输入有效的邮箱地址。',
    success: '提交成功！我们已收到您的信息，将尽快与您联系。',
    fail: '提交失败，请稍后重试。'
  },
  footer: {
    desc: '专注优质货源对接，帮助您更高效地完成采购与定制。',
    quickLinks: '快速入口',
    contactTitle: '联系方式',
    emailLine: "邮箱：2017emilyli{'@'}gmail.com",
    whatsappLine: 'WhatsApp：18666080334',
    addressLine: '地址：广东省广州市花都区花山镇',
    rights: '保留所有权利。'
  },
  lang: {
    label: '语言',
    zh: '中文',
    en: 'English',
    es: 'Español'
  },
  meta: {
    home: '商品展示',
    productDetail: '商品详情',
    cases: '采购实例',
    caseDetail: '案例详情',
    contact: '联系我们',
    admin: '数据管理后台',
    adminLogin: '后台登录'
  },
  cases: {
    title: '真实采购实例',
    subtitle:
      '看看我们如何帮助不同行业客户完成寻源、打样、质检与交付——用结果说话。',
    filterLabel: '案例类别',
    filterAll: '全部',
    filterEmpty: '该类别暂无案例，请切换其他类别。',
    viewDetail: '查看详情',
    backList: '← 返回采购实例',
    challenge: '客户挑战',
    solution: '我们的方案',
    result: '交付成果',
    highlights: '关键亮点',
    cta: '咨询类似项目',
    moreCases: '更多案例',
    notFoundTitle: '未找到该案例',
    notFoundDesc: '案例可能已下线，或链接无效。',
    metrics: {
      saving: '成本优化',
      units: '交付数量',
      leadTime: '交付周期'
    },
    items: {
      c1: {
        title: '跨境电商蓝牙音箱 OEM 项目',
        client: '北美电商品牌 · 消费电子',
        summary:
          '帮助客户在 8 周内完成外观改款、固件定制与首批发货，综合采购成本下降约 22%。',
        challenge:
          '客户原有供应商交期不稳定，且无法支持小批量固件改版。旺季临近，需要在保证音质与防水等级的前提下快速上线新 SKU。',
        solution:
          '我们筛选了 3 家具备出口经验的音箱工厂，完成样品对比与第三方检测；同步推进模具微调、包装设计与船期锁定，建立周报质检节点。',
        result:
          '首单 8.5 万台按期出货，不良率控制在 0.8% 以内；后续复购两轮，客户将我们列为独家中国采购伙伴。',
        highlights: [
          '完成 IPX5 防水与续航专项测试',
          '支持 OEM 外观与固件定制',
          '建立出货前 AQL 抽检流程'
        ]
      },
      c2: {
        title: '商超硅胶厨具礼盒定制',
        client: '欧洲零售连锁 · 厨房用品',
        summary:
          '为节日档期定制多色厨具礼盒，协助完成颜色打样、说明书多语言与防震出口包装。',
        challenge:
          '客户对颜色一致性与礼盒开箱体验要求极高，同时需要德/法/英三语说明书，且必须赶上圣诞档期船期。',
        solution:
          '锁定具备食品级硅胶认证的工厂，安排色板确认与小批量试产；包装采用双层防震结构，并提前预订舱位。',
        result:
          '12 万套礼盒按船期交付，开箱破损率低于 0.3%；客户续签下一年度节日系列合作。',
        highlights: [
          '食品级材质与出口认证齐全',
          '三语说明书与彩盒定制',
          '节日档期准时交付'
        ]
      },
      c3: {
        title: '工厂工具箱批量国产替代',
        client: '澳洲工业渠道商 · 工业用品',
        summary:
          '替换高成本进口工具箱，通过结构加固与内衬定制，实现约 31% 成本下降。',
        challenge:
          '客户现有产品来自欧美品牌，价格偏高；需要同等承重与耐用性，并支持经销商自有品牌丝印。',
        solution:
          '对标拆解原品结构，优化铰链与锁扣方案；安排承重与跌落测试，配套定制 EVA 内衬分区与 Logo 丝印。',
        result:
          '1.25 万套工具箱顺利交付，客户反馈终端复购率提升；单套成本显著低于原进口方案。',
        highlights: [
          '结构承重与跌落测试通过',
          '支持经销商品牌丝印',
          '相较进口方案明显降本'
        ]
      },
      c4: {
        title: '家居收纳盒电商铺货项目',
        client: '东南亚 DTC 品牌 · 家居百货',
        summary:
          '搭建多尺寸收纳盒 SKU 矩阵，支持彩盒与条码贴标，助力平台快速铺货。',
        challenge:
          '客户需要在短时间内上线 6 个尺寸组合，并满足平台对包装信息与条码的合规要求。',
        solution:
          '统一模具族规划，减少开模数量；同步推进包装设计、条码规则与仓配标签，分两批发货降低库存风险。',
        result:
          '累计交付超 20 万件，平台评分稳定在 4.7+；客户将我们纳入年度核心供应商清单。',
        highlights: [
          '多尺寸 SKU 快速上线',
          '彩盒与条码合规贴标',
          '分批发货降低库存压力'
        ]
      },
      c5: {
        title: '运动水杯品牌联名定制',
        client: '拉美运动品牌 · 运动户外',
        summary:
          '完成联名图案印刷、容量规格确认与出口检测，帮助品牌在新市场首发。',
        challenge:
          '联名图案对印刷精度要求高，且目标市场对食品接触材料有合规要求；客户希望控制首单风险。',
        solution:
          '采用食品级 Tritan 材质，安排印刷打样与色差确认；协助完成目标市场合规文件，并建议首单分规格试销。',
        result:
          '6 万件按期交付，联名款在首周售罄 70%；客户追加第二批订单并扩展新颜色。',
        highlights: [
          '食品级材质合规交付',
          '联名图案高精度印刷',
          '首发后快速追加订单'
        ]
      },
      c6: {
        title: '陶瓷餐具礼盒节日出口',
        client: '加拿大礼品公司 · 餐厨礼品',
        summary:
          '定制釉色与图案餐具礼盒，配套防震出口包装，确保长途海运完好率。',
        challenge:
          '陶瓷易碎且海运周期长，客户过往破损率偏高；同时需要定制釉色以匹配品牌视觉。',
        solution:
          '优化礼盒内托与外箱堆码强度，安排模拟运输测试；釉色经两轮确认后进入量产，质检按箱全检关键工序。',
        result:
          '4.8 万套礼盒顺利清关上架，到仓破损率下降到 0.5% 以下，客户年度复购。',
        highlights: [
          '定制釉色与图案',
          '防震包装显著降损',
          '节日渠道稳定供货'
        ]
      }
    }
  },
  products: {
    p1: {
      name: '工业工具箱套装',
      category: '工业用品',
      moq: '500 套',
      material: 'ABS + 钢材',
      leadTime: '15–25 天',
      description:
        '适用于工厂与维修场景的多规格工具箱。支持定制内衬分区、丝印 Logo 与颜色，可按订单批量出货。',
      specs: ['承重加固结构', '可定制内衬', '支持 OEM/ODM']
    },
    p2: {
      name: '家居收纳盒系列',
      category: '家居百货',
      moq: '1000 件',
      material: 'PP 塑料',
      leadTime: '12–20 天',
      description:
        '轻便耐用的家居收纳方案，提供多尺寸组合。适合电商平台铺货，支持彩盒包装与条码贴标。',
      specs: ['多尺寸可选', '可堆叠设计', '支持彩盒定制']
    },
    p3: {
      name: '户外运动水杯',
      category: '运动户外',
      moq: '2000 件',
      material: '食品级 Tritan',
      leadTime: '18–28 天',
      description:
        '轻量防漏运动水杯，适合跨境电商与品牌定制。支持颜色、容量、印刷图案与包装方案定制。',
      specs: ['食品级材质', '防漏密封', '可印刷品牌标识']
    },
    p4: {
      name: '厨房硅胶厨具组',
      category: '厨房用品',
      moq: '800 套',
      material: '食品级硅胶',
      leadTime: '20–30 天',
      description:
        '耐高温硅胶厨具组合，适合商超与礼品渠道。可按客户要求调整颜色组合、配件数量与说明书语言。',
      specs: ['耐高温', '不粘锅友好', '可组合套装']
    },
    p5: {
      name: '便携蓝牙音箱',
      category: '消费电子',
      moq: '500 台',
      material: 'ABS + 织物',
      leadTime: '25–35 天',
      description:
        '便携式蓝牙音箱，支持 OEM 外观与固件定制。可协助完成样品确认、质检与出口包装方案。',
      specs: ['IPX5 防水', '续航可定制', '支持固件定制']
    },
    p6: {
      name: '办公桌面收纳架',
      category: '办公用品',
      moq: '1000 件',
      material: '金属 + 木质',
      leadTime: '15–22 天',
      description:
        '简约风桌面收纳产品，适合办公室与家居场景。支持尺寸微调、表面处理与品牌标牌定制。',
      specs: ['稳固承重', '简约外观', '可定制标牌']
    },
    p7: {
      name: '儿童益智积木',
      category: '玩具礼品',
      moq: '600 套',
      material: '环保 ABS',
      leadTime: '22–30 天',
      description:
        '适合出口的益智积木产品，可提供安全检测配合与包装设计。支持角色主题与说明书多语言版本。',
      specs: ['符合出口安全要求', '可主题定制', '多语言说明书']
    },
    p8: {
      name: '旅行收纳袋套装',
      category: '箱包配件',
      moq: '1200 套',
      material: '尼龙 / 涤纶',
      leadTime: '14–21 天',
      description:
        '轻薄旅行收纳套装，支持多色组合与尺码搭配。适合电商爆款铺货与品牌联名包装。',
      specs: ['轻薄耐磨', '多件套组合', '可定制拉链色']
    },
    p9: {
      name: '陶瓷餐具礼盒',
      category: '餐厨礼品',
      moq: '400 套',
      material: '陶瓷',
      leadTime: '25–40 天',
      description:
        '礼盒装陶瓷餐具，适合节日礼品与商超渠道。可定制釉色、图案与防震包装方案。',
      specs: ['礼盒包装', '釉色可定制', '防震出口包装']
    },
    p10: {
      name: 'LED 氛围灯',
      category: '灯具照明',
      moq: '800 台',
      material: 'PC + 铝合金',
      leadTime: '20–30 天',
      description:
        '家居氛围灯产品，支持色温与控制方式定制。可协助完成样品打样、质检与批量出货安排。',
      specs: ['多色温可选', '支持遥控/APP', '可定制外观']
    },
    p11: {
      name: '运动护膝护具',
      category: '运动防护',
      moq: '1500 件',
      material: '氯丁橡胶 / 锦纶',
      leadTime: '16–24 天',
      description:
        '运动防护护具，支持尺码矩阵与包装方案。适合跨境电商与运动品牌代工合作。',
      specs: ['弹力透气', '多尺码', '可定制吊牌']
    },
    p12: {
      name: '不锈钢保温杯',
      category: '日用百货',
      moq: '1000 件',
      material: '304 不锈钢',
      leadTime: '18–26 天',
      description:
        '双层真空保温杯，支持外观喷涂、镭雕 Logo 与礼盒包装。适合企业礼品与零售渠道。',
      specs: ['真空保温', '可镭雕 Logo', '礼盒可选']
    }
  }
}
